<template>
  <div class="project-file" v-if="fileData">
    <div class="file-item">
      <div class="title">项目申请时的文档</div>
      <file-download @getFileList="getFileList" :data="fileData.applyAttas"></file-download>
      <el-upload v-if="isLeader" class="upload-demo" :before-upload="handleBeforeUpload" :action="uploadUrl" multiple
         :on-success="handleAvatarSuccess_0">
        <el-button size="small" type="primary" :loading="isUpload">点击上传项目申请相关文档</el-button>
      </el-upload>
    </div>
    <div class="file-item">
      <div class="title">项目立项时的文档</div>
      <file-download @getFileList="getFileList" :data="fileData.setupAttas"></file-download>
      <el-upload v-if="isLeader" class="upload-demo" :before-upload="handleBeforeUpload" :action="uploadUrl" multiple
         :on-success="handleAvatarSuccess_1">
        <el-button size="small" type="primary" :loading="isUpload">点击上传项目立项相关文档</el-button>
      </el-upload>
    </div>
    <div class="file-item">
      <div class="title">项目招标及合同相关文档</div>
      <file-download @getFileList="getFileList" :data="fileData.zbhtAttas"></file-download>
      <el-upload v-if="isLeader" class="upload-demo" :before-upload="handleBeforeUpload" :action="uploadUrl" multiple
         :on-success="handleAvatarSuccess_2">
        <el-button size="small" type="primary" :loading="isUpload">点击上传项目招标及合同相关文档</el-button>
      </el-upload>
    </div>
    <div class="file-item">
      <div class="title">项目实施中的文档</div>
      <file-download @getFileList="getFileList" :data="fileData.ssAttas"></file-download>
      <el-upload v-if="isLeader" class="upload-demo" :before-upload="handleBeforeUpload" :action="uploadUrl" multiple
         :on-success="handleAvatarSuccess_3">
        <el-button size="small" type="primary" :loading="isUpload">点击上传项目实施中的相关文档</el-button>
      </el-upload>
    </div>
    <div class="file-item">
      <div class="title">项目付款相关文档</div>
      <file-download @getFileList="getFileList" :data="fileData.payAttas"></file-download>
      <el-upload v-if="isLeader" class="upload-demo" :before-upload="handleBeforeUpload" :action="uploadUrl" multiple
         :on-success="handleAvatarSuccess_4">
        <el-button size="small" type="primary" :loading="isUpload">点击上传项目付款相关文档</el-button>
      </el-upload>
    </div>
  </div>
</template>
<script>
  import fileDownload from './fileDownload'
  export default {
    props: ['projectId', 'isLeader'],
    components: {
      fileDownload,
    },
    data() {
      return {
        isUpload: false,
        uploadUrl: axios.defaults.baseURL + '/common/upload',
        fileData: "",
        type: 0,

        // inviteFiles: [],
        // ssFiles: [],
        // payFiles: [],
      }
    },
    mounted() {
      this.getFileList()
    },
    methods: {
      isOfficeFile(type) {
        switch (type) {
          case 'doc':
          case 'docx':
          case 'xls':
          case 'xlsx':
          case 'ppt':
          case 'pptx':
            return true
            break;
          default:
            return false
            break;
        }
      },
      handleBeforeUpload() {
        this.isUpload = true
      },
      // 上传附件到对应列表
      relateUpload(type, res) {
        ajax.post("/gc/project/relate/files/upload", {
          projectId: this.projectId,
          type: type,
          attachments: res.vo.id
        }, (res) => {
          // 上传成功， 重新获取附件列表
          this.getFileList()
          this.isUpload = false
        })
      },
      // 点击上传附件
      handleAvatarSuccess_0(res, file) {
        this.relateUpload(0, res)
      },
      // 点击上传附件
      handleAvatarSuccess_1(res, file) {
        this.relateUpload(1, res)
      },
      // 点击上传附件
      handleAvatarSuccess_2(res, file) {
        this.relateUpload(2, res)
      },
      // 点击上传附件
      handleAvatarSuccess_3(res, file) {
        this.relateUpload(3, res)
      },
      // 点击上传附件
      handleAvatarSuccess_4(res, file) {
        this.relateUpload(4, res)
      },
      getFileList() {
        ajax.get('/gc/project/relate/files/' + this.projectId, '', (res) => {
          this.fileData = res.vo

          // this.inviteFiles = this.fileData.inviteAttas.concat(this.fileData.inviteSignAttas).concat(this.fileData.contractSignAttas)

          // this.ssFiles = this.fileData.kgAttas.concat(this.fileData.speedAttas).concat(this.fileData.ysAttas)

          // this.payFiles = this.fileData.jsAttas.concat(this.fileData.jxAttas).concat(this.fileData.paymentAttas)
        })
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/page/project/file.vue